import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import enHome from "./en/home.json";
import deHome from "./de/home.json";
import enProfile from "./en/profile.json";
import deProfile from "./de/profile.json";
import enExpertForm from "./en/order-an-expert.json";
import deExpertForm from "./de/order-an-expert.json";
import enCompaniesPage from "./en/companies-table.json";
import deCompaniesPage from "./de/companies-table.json";
import enCreateCompanyForm from "./en/create-company-form.json";
import deCreateCompanyForm from "./de/create-company-form.json";
import enEvaluationPage from "./en/evaluation-page.json";
import deEvaluationPage from "./de/evaluation-page.json";
import deCreateQuestionList from "./de/create-question-list.json";
import enCreateQuestionList from "./en/create-question-list.json";
import enMyQuestionsLists from "./en/my-question-lists.json";
import deMyQuestionsLists from "./de/my-question-lists.json";
import enRealeaseNotes from "./en/release-notes.json";
import deRealeaseNotes from "./de/release-notes.json";
import enDashboard from "./en/dashboard-menu.json";
import deDashboard from "./de/dashboard-menu.json";
import enDashboardLayout from "./en/dashboard.json";
import deDashboardLayout from "./de/dashboard.json";
import enChatWithExpert from "./en/chat-with-experts.json";
import deChatWithExpert from "./de/chat-with-experts.json";
import enEvaluation from "./en/evaluation.json";
import deEvaluation from "./de/evaluation.json";
import enSingleCompanyComponent from "./en/single-company-component.json";
import deSingleCompanyComponent from "./de/single-company-component.json";
import deWebsiteUpload from "./de/website-upload.json";
import enWebsiteUpload from "./en/website-upload.json";
import deDocumentUpload from "./de/document-upload.json";
import enDocumentUpload from "./en/document-upload.json";
import enCreateKnowledgeBase from "./en/knowledge-base.json";
import deCreateKnowledgeBase from "./de/knowledge-base.json";
import enGradeDescription from "./en/grade-description.json";
import deGradeDescription from "./de/grade-description.json";
import enSnack from "./en/snack.json";
import deSnack from "./de/snack.json";
import enUsers from "./en/users.json";
import deUsers from "./de/users.json";
import enUserProfilePage from "./en/user-profile-page.json";
import deUserProfilePage from "./de/user-profile-page.json";
import enCertCategories from "./en/certification-categories.json";
import deCertCategories from "./de/certification-categories.json";
import enCreateUser from "./en/create-user-page.json";
import deCreateUser from "./de/create-user-page.json";
import enWorkspaces from "./en/workspaces.json";
import deWorkspaces from "./de/workspaces.json";
import enModal from "./en/modal.json";
import deModal from "./de/modal.json";
import enActionLog from "./en/action-log.json";
import deActionLog from "./de/action-log.json";
import enAlanCredentials from "./en/alan-credentials.json";
import deAlanCredentials from "./de/alan-credentials.json";
import enMonitoring from "./en/monitoring.json";
import deMonitoring from "./de/monitoring.json";
import enRetrievalTest from "./en/retrieval-test.json";
import deRetrievalTest from "./de/retrieval-test.json";
import enComoExperts from "./en/como-experts.json";
import deComoExperts from "./de/como-experts.json";
import enGradingCriteria from "./en/gradingCriteria.json";
import deGradingCriteria from "./de/gradingCriteria.json";
import enComoAgentForm from "./en/agent-form.json";
import deComoAgentForm from "./de/agent-form.json";
import enMcpConnectionForm from "./en/mcp-connection.json";
import deMcpConnectionForm from "./de/mcp-connection.json";
import enScheduledTasks from "./en/scheduled-task.json";
import deScheduledTasks from "./de/scheduled-task.json";
import enSkillForm from "./en/skill.json";
import deSkillForm from "./de/skill.json";
import enUsage from "./en/usage.json";
import deUsage from "./de/usage.json";
import enSharepointSync from "./en/sharepoint-sync.json";
import deSharepointSync from "./de/sharepoint-sync.json";
import enAdminDashboard from "./en/admin-dashboard.json";
import deAdminDashboard from "./de/admin-dashboard.json";
import enFeatureCatalog from "./en/feature-catalog.json";
import deFeatureCatalog from "./de/feature-catalog.json";
import enVoicesCommon from "./en/voices-common.json";
import deVoicesCommon from "./de/voices-common.json";
import enVoicesProfiles from "./en/voices-profiles.json";
import deVoicesProfiles from "./de/voices-profiles.json";
import enVoicesSettings from "./en/voices-settings.json";
import deVoicesSettings from "./de/voices-settings.json";
import enVoicesUsage from "./en/voices-usage.json";
import deVoicesUsage from "./de/voices-usage.json";
import enVoicesCampaigns from "./en/voices-campaigns.json";
import deVoicesCampaigns from "./de/voices-campaigns.json";
import enVoicesTopics from "./en/voices-topics.json";
import deVoicesTopics from "./de/voices-topics.json";
import enVoicesPosts from "./en/voices-posts.json";
import deVoicesPosts from "./de/voices-posts.json";
import enHelpDesk from "./en/help-desk.json";
import deHelpDesk from "./de/help-desk.json";
import enAmbassador from "./en/ambassador.json";
import deAmbassador from "./de/ambassador.json";

const savedLng = localStorage.getItem("i18nextLng") || "de";

i18n.use(initReactI18next).init({
  lng: savedLng,
  fallbackLng: "de",
  resources: {
    en: {
      snack: enSnack,
      home: enHome,
      profile: enProfile,
      expertForm: enExpertForm,
      companiesPage: enCompaniesPage,
      createCompanyForm: enCreateCompanyForm,
      evaluationPage: enEvaluationPage,
      createQuestionList: enCreateQuestionList,
      myQuestionLists: enMyQuestionsLists,
      releaseNotes: enRealeaseNotes,
      dashboard: enDashboard,
      dashboardLayout: enDashboardLayout,
      chatWithExperts: enChatWithExpert,
      evaluation: enEvaluation,
      singleCompanyComponent: enSingleCompanyComponent,
      websiteUpload: enWebsiteUpload,
      documentUpload: enDocumentUpload,
      createKnowledgeBase: enCreateKnowledgeBase,
      gradeDescription: enGradeDescription,
      userPage: enUsers,
      actionLog: enActionLog,
      userProfilePage: enUserProfilePage,
      certCategories: enCertCategories,
      createUser: enCreateUser,
      workspaces: enWorkspaces,
      modal: enModal,
      credentials: enAlanCredentials,
      monitoring: enMonitoring,
      retrievalTest: enRetrievalTest,
      comoExperts: enComoExperts,
      gradingCriteria: enGradingCriteria,
      comoAgentForm: enComoAgentForm,
      mcpConnectionForm: enMcpConnectionForm,
      scheduledTasks: enScheduledTasks,
      skillForm: enSkillForm,
      usage: enUsage,
      sharepointSync: enSharepointSync,
      adminDashboard: enAdminDashboard,
      featureCatalog: enFeatureCatalog,
      voicesCommon: enVoicesCommon,
      voicesProfiles: enVoicesProfiles,
      voicesSettings: enVoicesSettings,
      voicesUsage: enVoicesUsage,
      voicesCampaigns: enVoicesCampaigns,
      voicesTopics: enVoicesTopics,
      voicesPosts: enVoicesPosts,
      helpDesk: enHelpDesk,
      ambassador: enAmbassador,
    },
    de: {
      snack: deSnack,
      home: deHome,
      profile: deProfile,
      expertForm: deExpertForm,
      companiesPage: deCompaniesPage,
      createCompanyForm: deCreateCompanyForm,
      evaluationPage: deEvaluationPage,
      createQuestionList: deCreateQuestionList,
      myQuestionLists: deMyQuestionsLists,
      releaseNotes: deRealeaseNotes,
      dashboard: deDashboard,
      dashboardLayout: deDashboardLayout,
      chatWithExperts: deChatWithExpert,
      evaluation: deEvaluation,
      singleCompanyComponent: deSingleCompanyComponent,
      websiteUpload: deWebsiteUpload,
      documentUpload: deDocumentUpload,
      createKnowledgeBase: deCreateKnowledgeBase,
      gradeDescription: deGradeDescription,
      userPage: deUsers,
      actionLog: deActionLog,
      userProfilePage: deUserProfilePage,
      certCategories: deCertCategories,
      createUser: deCreateUser,
      workspaces: deWorkspaces,
      modal: deModal,
      credentials: deAlanCredentials,
      monitoring: deMonitoring,
      retrievalTest: deRetrievalTest,
      comoExperts: deComoExperts,
      gradingCriteria: deGradingCriteria,
      comoAgentForm: deComoAgentForm,
      mcpConnectionForm: deMcpConnectionForm,
      scheduledTasks: deScheduledTasks,
      skillForm: deSkillForm,
      usage: deUsage,
      sharepointSync: deSharepointSync,
      adminDashboard: deAdminDashboard,
      featureCatalog: deFeatureCatalog,
      voicesCommon: deVoicesCommon,
      voicesProfiles: deVoicesProfiles,
      voicesSettings: deVoicesSettings,
      voicesUsage: deVoicesUsage,
      voicesCampaigns: deVoicesCampaigns,
      voicesTopics: deVoicesTopics,
      voicesPosts: deVoicesPosts,
      helpDesk: deHelpDesk,
      ambassador: deAmbassador,
    },
  },
  ns: [
    "snack",
    "home",
    "profile",
    "expertForm",
    "companiesPage",
    "createCompanyForm",
    "evaluationPage",
    "createQuestionList",
    "myQuestionLists",
    "releaseNotes",
    "dashboard",
    "dashboardLayout",
    "chatWithExperts",
    "evaluation",
    "singleCompanyComponent",
    "websiteUpload",
    "documentUpload",
    "createKnowledgeBase",
    "gradeDescription",
    "userPage",
    "userProfilePage",
    "certCategories",
    "createUser",
    "workspaces",
    "modal",
    "credentials",
    "monitoring",
    "retrievalTest",
    "comoExperts",
    "gradingCriteria",
    "agentForm",
    "mcpConnectionForm",
    "scheduledTasks",
    "skillForm",
    "usage",
    "sharepointSync",
    "adminDashboard",
    "featureCatalog",
    "voicesCommon",
    "voicesProfiles",
    "voicesSettings",
    "voicesUsage",
    "voicesCampaigns",
    "voicesTopics",
    "voicesPosts",
    "helpDesk",
    "ambassador",
  ],
  defaultNS: "home",
  interpolation: { escapeValue: false },
});

export default i18n;
